<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="service w">
    <Row class="component-title">
      <Col span="24" class="fs-225px">服务流程</Col>
    </Row>
    <div class="process"></div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

export default {
  name: 'serviceComponent',
  props: {},
  mixins: [],
  components: {
    // swiper,
    // swiperSlide
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';

.service {
  padding-bottom: 4.53vw; //87px;
  .component-title {
    padding: 5.3125vw 0 4.79vw 0; //102px 0 92px 0;
  }
  .process {
    height: 7.81vw; //150px;
    background-image: url('/static/images/background/service.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
  }
}
.fs-225px {
  font-size: 22.5px;
}
</style>
